import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Popover, Button, IconButton, TextField } from "@mui/material";
import dayjs from "dayjs";
import React, { useState } from "react";


const DateRangePicker = ({ startDate,
  setStartDate,
  endDate,
  setEndDate }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  // Handle button click to open popover
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Clear both dates
  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const open = Boolean(anchorEl);
  const formattedRange =
    startDate && endDate
      ? `${dayjs(startDate).format("YYYY-MM-DD")} - ${dayjs(endDate).format("YYYY-MM-DD")}`
      : "Choose Date Range ▼";

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="relative z-50">
        <button
          className="h-[32px] max-sm:h-fit max-sm:p-2 w-[220px] border rounded-lg text-base border-[#000048] hover:bg-tertiary hover:text-primary transition-colors duration-500 gap-1 shadow-md"
          onClick={handleClick}
        >
          {formattedRange}
        </button>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <div className="p-2 w-[260px] bg-white shadow-lg rounded-lg flex flex-col gap-2">
            <DatePicker
              label="From Date"
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              maxDate={endDate}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  sx={{ width: "10%", fontSize: "8px" }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {startDate && (
                          <IconButton onClick={() => setStartDate(null)} size="small">
                          </IconButton>
                        )}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <DatePicker
              label="To Date"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              minDate={startDate}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  sx={{ width: "10%", fontSize: "8px" }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {endDate && (
                          <IconButton onClick={() => setEndDate(null)} size="small">
                          </IconButton>
                        )}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <div className="flex justify-between mt-2">
              <Button variant="text" sx={{ fontSize: "12px", padding: "4px 8px" }} onClick={handleClear}>
                Clear
              </Button>
              <div>
                <Button variant="text" sx={{ fontSize: "12px", padding: "4px 8px" }} onClick={handleClose}>
                  Close
                </Button>
                {/* <Button variant="contained" sx={{ fontSize: "12px", padding: "4px 8px" }} onClick={handleClose}>
                  Apply
                </Button> */}
              </div>
            </div>
          </div>
        </Popover>
      </div>
    </LocalizationProvider>
  );
};

export default DateRangePicker;
